import React, { PureComponent } from 'react';

// import i18n from '../../i18n';
import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import styles from './ContactListPage.module.scss';
import Hero from '../../components/Hero';
import StreamField from '../../components/StreamField';

class ContactListPage extends PureComponent {
    state = {};

    static defaultProps = {
        hero: null,
        contentBlocks: [],
    };

    static propTypes = {
        hero: PropTypes.object,
        contentBlocks: PropTypes.array,
    };

    render() {
        const { hero, contentBlocks } = this.props;
        return (
            <main className={styles['ContactListPage']}>
                <Hero {...hero} title={null} />
                <article className={styles['ContactListPage__Grid']}>
                    {(hero?.title || hero?.preamble) && (
                        <header
                            className={styles['ContactListPage__EntryWrapper']}>
                            <h1 className={styles['ContactListPage__Heading']}>
                                {hero.title}
                            </h1>
                            <p className={styles['ContactListPage__Preamble']}>
                                {hero.preamble}
                            </p>
                        </header>
                    )}
                </article>
                {!!contentBlocks.length && (
                    <StreamField items={contentBlocks} />
                )}
            </main>
        );
    }
}

export default basePageWrap(ContactListPage);
